import { Injectable } from '@angular/core';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';
import { MerchantAccountStatus } from '../../core/constants';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { StorageService } from '../../core/storage/storageService';
import { Merchant } from './merchant';
import { Account } from '../account/account';
import { AssignedUser } from '../users/assignedUser';
import { Logging } from '../../core/logging';
import { MerchantAPIInfoData } from './merchantApiInfoData';
import { MerchantAPIScope } from './merchantAPIScope';
import { MerchantProcessor } from './merchantProcessor';

@Injectable({
  providedIn: 'root',
})
export class MerchantService {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  // TODO (jacob):
  /*
    queryToMerchant(query: string): Promise<Merchant[]> {
        return this.api.apiCallSane(
            '/merchant',
            'GET',
            this.api.getDefaultHeaders(),
            {query},
            null,
            this.options
        ).then((ms: Partial<Merchant>[]) =>  
            ms.map(m => new Merchant(m)));
    }
    */

  get(data: any): Promise<Merchant> {
    return this.api
      .apiCallSane(
        '/merchant',
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
      )
      .then((data) => {
        return data;
      })
      .then((response: Partial<Merchant>) => new Merchant(response));
  }

  getMyMerchants(
    query: string,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<Merchant>> {
    return this.getPaged(
      '',
      query,
      pageNum,
      pageSize,
      sortColumn,
      sortDirection,
      true,
      '',
    );
  }

  public syncStatements(merchantInfo: Account | undefined): Promise<any> {
    this.storage.setSyncingStatements(true);

    let data = {
      merchantInfo: merchantInfo?.locations,
    };

    return this.api
      .apiCallSane(
        '/merchant/statements/sync',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        data,
        this.options,
      )
      .then((response: any) => {
        //console.log("Sync statements response", response);
      })
      .finally(() => {
        this.storage.setSyncingStatements(false);
      });
  }
  /*
    getFavoriteMerchants(query:string, pageNum:number, pageSize:number, 
        sortColumn:string, sortDirection:string): Promise<Page<Merchant>> {

            let data = {
                pageNum: pageNum,
                pageSize: pageSize,
                sortColumn:sortColumn,
                sortDirection: sortDirection,
                q: query,
            }
    
            return this.api.apiCallSane(
                '/merchants/favorite',
                'GET',
                this.api.getDefaultHeaders(),
                data,
                null,
                this.options
            ).then((response: Partial<Page<Merchant>>) => new Page<Merchant>(response))
        }
*/

  getPaged(
    accountId: string,
    query: string,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
    restrictToMyMerchants: boolean,
    userId: string,
  ): Promise<Page<Merchant>> {
    let data = {
      pageNum: pageNum,
      pageSize: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      businessId: accountId,
      restrictToMyMerchants: restrictToMyMerchants,
      q: query,
      userId: userId,
    };

    let myMerchants = '';

    if (restrictToMyMerchants) {
      myMerchants = '/my';
    }

    if (userId != '') {
      myMerchants = '/by-user';
    }

    return this.api
      .apiCallSane(
        '/merchants' + myMerchants,
        'GET',
        this.api.getDefaultHeaders(),
        data,
        null,
        this.options,
        // ).then((raw:any) => {

        //     const response: Partial<Page<Merchant>> | undefined =
        //     raw && (Array.isArray(raw.records) || Array.isArray(raw?.data?.records))
        //       ? (raw.records ? raw : raw.data)
        //       : raw;

        //   if (!response) {
        //     // Bubble a *real* error to be caught upstream
        //     throw new Error('Malformed response: response is undefined/null');
        //   }

        //   console.log("response", response);

        //   // If Page expects `items` to be an array, ensure it is
        //   if (!Array.isArray((response as any).records)) {
        //     throw new Error('Malformed response: response.items is not an array');
        //   }

        //   return new Page<Merchant>(response);
        // })
      )
      .then(
        (response: Partial<Page<Merchant>>) => new Page<Merchant>(response),
      );
  }

  post(data: any, which: string = ''): Promise<string> {
    let endpointLocation = '';

    if (which != '') {
      endpointLocation = '/' + which;
    }

    return this.api.apiCallSane(
      '/merchant' + endpointLocation,
      'POST',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
      //).then((response:{merchants: Partial<Merchant>[]}) => response.merchants.map(m => new Merchant(m))[0]);
    );
  }

  // TODO: remove [which], update endpoint merchant/(PATCH) to look for changed fields in request
  patch(data: any, which: string): Promise<any> {
    let endpointLocation = '';

    if (which != '') {
      endpointLocation = '/' + which;
    }

    return this.api.apiCallSane(
      '/merchant' + endpointLocation,
      'PATCH',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
    );
  }

  put(data: any, which: string): Promise<any> {
    let endpointLocation = '';

    if (which != '') {
      endpointLocation = '/' + which;
    }

    return this.api.apiCallSane(
      '/merchant' + endpointLocation,
      'PUT',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
    );
  }

  delete(data: any, which: string): Promise<any> {
    let endpointLocation = '';

    if (which != '') {
      endpointLocation = '/' + which;
    }

    return this.api.apiCallSane(
      '/merchant' + endpointLocation,
      'DELETE',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
    );
  }

  addMyMerchant(merchantId: string, userId: string): void {
    this.api.apiCallSane(
      '/merchant/my',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      { merchantId: merchantId, userId: userId, selected: true },
      this.options,
    );
  }

  removeMyMerchant(merchantId: string, userId: string): void {
    this.api.apiCallSane(
      '/merchant/my',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      { merchantId: merchantId, userId: userId, selected: false },
      this.options,
    );
  }

  updateMerchantAPIScopes(
    clientId: string,
    sandboxClientId: string,
    scope: MerchantAPIScope,
    sandbox: boolean,
  ): Promise<MerchantAPIInfoData> {
    return this.api.apiCallSane(
      '/merchant/api-scope',
      'PUT',
      this.api.getDefaultHeaders(),
      null,
      {
        clientId: clientId,
        sandboxClientId: sandboxClientId,
        scope: scope,
        sandbox: sandbox,
      },
      this.options,
    );
  }

  updateMerchantAPIAccess(
    merchantId: string,
    clientId: string,
    sandboxClientId: string,
    enabled: boolean,
    sandbox: boolean,
    userId: string,
  ): Promise<any> {
    return this.api.apiCallSane(
      '/merchant/api-access',
      'PUT',
      this.api.getDefaultHeaders(),
      null,
      {
        merchantId: merchantId,
        clientId: clientId,
        sandboxClientId: sandboxClientId,
        enabled: enabled,
        sandbox: sandbox,
        userId: userId,
      },
      this.options,
    );
  }

  async checkTokenVaultNameUsed(tokenVaultName: string): Promise<boolean> {
    return await this.api.apiCallSane(
      '/merchant/token-vault-name-used/' + tokenVaultName,
      'GET',
      this.api.getDefaultHeaders(),
      null,
      null,
      this.options,
    );
  }

  async getMerchantAPIInfo(merchantId: string): Promise<MerchantAPIInfoData> {
    return await this.api.apiCallSane(
      '/merchant/api-info/' + merchantId,
      'GET',
      this.api.getDefaultHeaders(),
      null,
      null,
      this.options,
    );
  }

  async addMerchantAccount(m: Partial<Merchant>): Promise<string> {
    return this.post(m);
  }

  async getMerchantById(id: string): Promise<Merchant> {
    return await this.get({ id });
  }

  async patchMerchantBusinessInfo(data: Partial<Merchant>): Promise<any> {
    return await this.patch(data, 'business-info');
  }

  async patchMerchantBillingInfo(data: Partial<Merchant>): Promise<any> {
    return await this.patch(data, 'billing-info');
  }

  async patchMerchantAPIInfo(data: Partial<Merchant>): Promise<any> {
    return await this.patch(data, 'api-info');
  }

  async patchMerchantAccountStatus(
    merchantId: string,
    status: MerchantAccountStatus,
  ): Promise<any> {
    let data = {
      merchantId: merchantId,
      accountStatus: parseInt(status.toString()),
    };
    return await this.patch(data, '');
  }

  async patchMerchantProcessor(
    data: Partial<MerchantProcessor>[],
  ): Promise<any> {
    return await this.patch(data, 'processing-info');
  }

  async insertMerchantContactInfo(
    contact: Partial<AssignedUser>,
    merchantId: string,
  ): Promise<any> {
    let data = {
      merchantId: merchantId,
      contact: contact,
    };

    return await this.post(data, 'user');
  }

  async patchMerchantContactInfo(contact: Partial<AssignedUser>): Promise<any> {
    return await this.put(contact, 'user');
  }

  async deleteMerchantContactInfo(
    merchantId: string,
    userId: string,
  ): Promise<any> {
    let data = {
      merchantId: merchantId,
      userId: userId,
    };

    return await this.delete(data, 'user');
  }
}
